// extracted by mini-css-extract-plugin
module.exports = {"root":"termos-e-condicoes-para-vendedores_root__19fg0","title":"termos-e-condicoes-para-vendedores_title__4IKCn","text":"termos-e-condicoes-para-vendedores_text__E4qCQ"};